export const deep = (obj1, obj2 = {}) => {
	let key
	for (key in obj2) {
		obj1[key] = obj1[key] && obj1[key].toString() === '[object Object]' && (obj2[key] && obj2[key].toString() === '[object Object]') ? this.deepMerge(obj1[key], obj2[key]) : (obj1[key] = obj2[key])
	}
	return obj1
}

export const listToTree = (list = [], getid = (i) => i.id, getpid = (i) => i.pid, hander) => {
	// console.log(list)
	const root = []
	//转换为字典
	const idAndItem = new Map()
	list.forEach((item) => {
		const id = getid?.(item) || 0
		const pid = getpid(item) || 0

		if (idAndItem.has(id)) {
			console.log('ID重复,', item, idAndItem.get(id))
			return
		}
		idAndItem.set(id, item)
		item.children = []
		item._id = id//给一个id
		item._pid = pid
		if (!pid || Number(pid) === 0) {
			// console.log(pid)
			root.push(item)
			hander && hander({}, item)
		}
	})
	// const items = list.filter(i => getpid(i))
	list.forEach((item) => {
		if (!item._pid) {
			return
		}
		const parent = idAndItem.get(item._pid)
		parent?.children?.push(item)
		item._parent = {
			_id: item._id,
			_pid: item._pid
		}//序列化时可能被递归引用
		hander && hander(parent, item)
	})
	// console.log(list,root)
	return root
}
